(async () => {

  if (!customElements.get('country-popup')) {

    const { Fancybox } = await import("@fancyapps/ui");

    class CountryPopup extends HTMLElement {
      constructor() {
        super();

        const country_popup_wrapper_identifier = "#country-message";

        this.country_popup_wrapper = document.getElementById('country-message');
        this.button_stay = this.country_popup_wrapper.querySelector('[data-country-message-stay]');
        this.country_code = '';

        // guard: check country popup exists
        if (this.country_popup_wrapper.length == 0) {
          return;
        }

        // guard: check fancybox object exists
        if (typeof Fancybox ==! 'object') {
          return;
        }

        // get options
        let defaults = {
          'current_country_code' : 'EN',
          'location_api_url' : '',
          'location_field_name' : '',
          'popup_messages' : {}
        };

        let metaOptions = this.country_popup_wrapper.dataset.countryMessageOptions;
        this.options = Object.assign(defaults, JSON.parse(metaOptions));

        // set country popup cookie identifier
        this.country_popup_cookie_identifier = "country_popup";

        this.init();

      }

      init() {

        // if country popup days is set to zero, remove cookie if exists
        if (parseInt(this.options.expires_in_days) == 0) {
          document.cookie = 'country_popup; path=/; max-age=0';
        }

        // Get cookie
        this.countryPopupCookie = this.getCookie("country_popup");

        // Render country popup if given
        if (!this.mayRenderCountryPopup()) {
          return false;
        }

        // get country location
        this.getLocation();

        this.button_stay.addEventListener('click', this.closeCountryPopup);
      }

      mayRenderCountryPopup() {
        // guard: check if popup cookie is set
        if ( this.countryPopupCookie ) {
          return false;
        }
        // guard: check if there are messages given
        if (this.options.popup_messages.length == 0) {
          return false;
        }
        return true;
      }

      getLocation() {

        // get country code from cookie
        this.country_code = this.getCookie("country_popup-country_code");

        // if country code is given, return the code
        if (this.country_code) {
          this.renderCountryPopup();
        } else {
          this.getCountryCodeFromAPI()
        }
      }

      getCountryCodeFromAPI() {
        let default_api_url = '//extreme-ip-lookup.com/json/?key=NupEkXcGAMuUWSdFosnX';
        let country_code_api = this.options.location_api_url || default_api_url;
        let country_code_fieldname_identifier = this.options.location_field_name || 'countryCode';

        // guard: get country code api url from options
        if (country_code_api == '') {
          return self;
        }
        // guard: get country code field name
        if (country_code_fieldname_identifier == '') {
          return self;
        }

        // get country coude from api
        let that = this;

        fetch(country_code_api)
        .then(res => res.json())
        .then(function (res) {
          if (typeof res[country_code_fieldname_identifier] !== 'undefined' && res[country_code_fieldname_identifier] != '') {
            that.country_code = res[country_code_fieldname_identifier];
            that.renderCountryPopup();
          }
        })
        .catch(function(e) {
          console.log(e)
        });
      }

      done(callback) {
        if (typeof calback == "object") {
          callback( this.country_code );
        }
        return this;
      }

      renderCountryPopup() {

        // check country code is given
        if (this.country_code == '' || this.options.current_country_code == '') {
          return;
        }

        // guard: if the given country_Code is the same as the shop country code then skip!
        if ( this.country_code == this.options.current_country_code ) {
          return;
        }

        let countryData = '';

        // get the data by country code if available
        if ( typeof this.options.popup_messages[this.country_code] != 'undefined' ) {
          countryData = this.options.popup_messages[this.country_code];

        // if country option does not exists shop ROW
        } else if ( typeof this.options.popup_messages['ROW'] != 'undefined' ) {
          countryData = this.options.popup_messages['ROW'];

        // guard: no country data to render
        } else {
          return;
        }

        // populate the wrapper with the country data
        this.country_popup_wrapper.querySelector('[data-country-message-title]').innerHTML = countryData.country_title || '';
        this.country_popup_wrapper.querySelector('[data-country-message-name-title]').innerHTML = countryData.country_name || '';
        this.country_popup_wrapper.querySelector('[data-country-message-text]').innerHTML = countryData.country_body || '';
        this.country_popup_wrapper.querySelector('[data-country-message-url]').setAttribute('href', countryData.country_url || '');
        this.country_popup_wrapper.querySelector('[data-country-message-label]').innerHTML = countryData.country_button || '';
        this.country_popup_wrapper.querySelector('[data-country-message-stay]').value = countryData.country_stay || '';

        Fancybox.show(
          [
            {
              src: this.country_popup_wrapper,
              type: "html",
            }
          ]
        )

        // set enable cookie
        document.cookie = `country_popup=true; path=/; max-age=${60 * 60 * 24 * 14};`;
            
      }

      closeCountryPopup() {
        document.cookie = `country_popup=false; path=/; max-age=${60 * 60 * 24 * 14};`;
        Fancybox.close();
      }

      getCookie (name) {
        let value = `; ${document.cookie}`;
        let parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
      }

    }


    window.CountryPopup = CountryPopup;
    customElements.define('country-popup', CountryPopup);
  }
})();
